(function () {
  function setAccordionState(button) {
    var item = button.closest("[data-faq-item]");
    var answer = document.getElementById(button.getAttribute("aria-controls"));
    if (!item || !answer) return;
    var open = item.classList.toggle("open");
    button.setAttribute("aria-expanded", open ? "true" : "false");
    answer.style.maxHeight = open ? answer.scrollHeight + "px" : "0px";
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest("[data-faq-trigger]");
    if (button) setAccordionState(button);
  });

  var page = document.querySelector("[data-faq-page]");
  if (!page) return;
  var links = Array.prototype.slice.call(page.querySelectorAll("[data-faq-category-link]"));
  var chapters = Array.prototype.slice.call(page.querySelectorAll("[data-faq-category]"));
  if (!links.length || !chapters.length) return;

  function updateStickyOffset() {
    var header = document.querySelector(".relenser-site-header, #header-component");
    var headerBottom = 0;
    if (header) {
      var headerRect = header.getBoundingClientRect();
      if (headerRect.bottom > 0 && headerRect.top < window.innerHeight) {
        headerBottom = Math.max(0, Math.ceil(headerRect.bottom));
      }
    }
    page.style.setProperty("--faq-sticky-top", headerBottom + "px");
    return headerBottom;
  }

  function activate(id) {
    links.forEach(function (link) {
      var active = link.getAttribute("data-faq-category-link") === id;
      link.classList.toggle("active", active);
      if (active) link.setAttribute("aria-current", "true");
      else link.removeAttribute("aria-current");
    });
  }

  var ticking = false;
  function updateFromScroll() {
    var headerBottom = updateStickyOffset();
    var nav = page.querySelector(".pillnav-wrap");
    var heading = page.querySelector(".faqpage-head");
    if (nav && heading) {
      nav.classList.toggle("is-stuck", window.scrollY > 0 && heading.getBoundingClientRect().bottom <= headerBottom);
    }
    var threshold = (nav ? nav.getBoundingClientRect().bottom : 0) + 24;
    var current = chapters[0];
    chapters.forEach(function (chapter) {
      if (chapter.getBoundingClientRect().top <= threshold) current = chapter;
    });
    activate(current.id);
    ticking = false;
  }

  links.forEach(function (link) {
    link.addEventListener("click", function () {
      activate(link.getAttribute("data-faq-category-link"));
    });
  });
  window.addEventListener("scroll", function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateFromScroll);
  }, { passive: true });
  window.addEventListener("resize", function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateFromScroll);
  });
  updateFromScroll();
})();
